import '@module/Rating/Rating.scss';
import { classList, documentReady, fadeOut, lreplace, qs, qsa } from '@utils/toolbox';
import { ConnectApi } from '@js/plugins/connectApi';

const rating = {
	initialize () {
		this.selectors = {
			container: '#vote-container',
			button: '.vote-button',
			text: '.rating-text'
		};

		this.elems = {
			container: qs(this.selectors.container),
			text: qs(this.selectors.text),
			buttons: qsa(this.selectors.button)
		};

		if (!this.elems.container) {
			return;
		}


		this.elems.container.addEventListener('click', (event) => {
			const target = event.target.closest(this.selectors.button);
			if (target) {
				event.stopPropagation();
				event.preventDefault();

				this.vote(target);
			}
		});

		// Toggle the icon on hover
		this.voteButtons = qsa('.vote-button');
		this.voteButtonsIcons = qsa('.vote-button .icon');
		this.ratingAverage = js_params.module.Rating.ratingAverage;

		this.voteButtons.forEach((element) => {
			element.addEventListener('mouseover', () => {
				const hoverIndex = this.voteButtons.indexOf(element);
				this.updateIcons(hoverIndex);
			});

			element.addEventListener('mouseout', () => {
				this.updateIcons(this.ratingAverage - 1);
			});
		});
	},
	updateIcons (numberOfStars) {
		this.voteButtons.forEach((element, index) => {
			const icon = this.voteButtonsIcons[index];

			classList(icon).remove('icon-star-full', 'icon-star-empty');
			classList(icon).add(index <= numberOfStars ? 'icon-star-full' : 'icon-star-empty');
		});
	},
	vote (element) {
		ConnectApi('Rating', 'vote', [element.dataset.id, element.dataset.value, this.elems.container.dataset.type]).then((data) => {
			// Callback - Update vote text with new value
			this.ratingAverage = Math.round(data.rating_total / data.rating_count);
			this.elems.container.innerHTML = lreplace('destinationPage.rating.rate', { ratingAverage: this.ratingAverage, ratingCount: data.rating_count });
		});
		this.hideVoteButtons();
	},
	hideVoteButtons () {
		this.elems.buttons.forEach((element) => {
			fadeOut(element);
		});
	}
};


documentReady(function () {
	rating.initialize();
});
